(function () {
  const SELECTOR = '[data-cart-audio]';
  const INIT_ATTR = 'data-cart-audio-init';

  // window.__CART_AUDIO_DEBUG__ = true
  function log(...args) {
    if (window.__CART_AUDIO_DEBUG__) console.log('[CartWaveform]', ...args);
  }

  function clamp(n, min, max) { return Math.max(min, Math.min(max, n)); }
  function parseBool(v) { if (typeof v === 'boolean') return v; return String(v).toLowerCase() === 'true'; }
  function formatTime(seconds) {
    seconds = Math.max(0, seconds || 0);
    const m = Math.floor(seconds / 60);
    const s = Math.floor(seconds % 60);
    return `${m}:${String(s).padStart(2,'0')}`;
  }
  function splitPipe(s){ return String(s||'').split('|').map(x=>x.trim()).filter(Boolean); }
  function dedupeKeepOrder(arr){
    const out=[]; const seen=new Set();
    for(const v of arr){
      const k=String(v||'').trim(); if(!k) continue;
      if(seen.has(k)) continue; seen.add(k); out.push(k);
    }
    return out;
  }

  // one player at a time
  let active = null; // { audio, ui, el, lineKey }

  function stopActive() {
    if (!active) return;
    try { active.audio.pause(); if (active.ui && active.ui.btn) active.ui.btn.textContent = '▶'; } catch(e){}
    active = null;
  }
  function stopAllCartAudio() {
    document.body.dispatchEvent(new CustomEvent('pauseAllCartAudio'));
  }
  if (!window.__cartWaveformGlobalPauseBound) {
    window.__cartWaveformGlobalPauseBound = true;
    document.body.addEventListener('pauseAllCartAudio', () => stopActive());
  }

  function ensureStyles() {
    if (document.getElementById('cart-audio-player-styles')) return;
    const style = document.createElement('style');
    style.id = 'cart-audio-player-styles';
    style.textContent = `

      .cart-audio-preview { margin-top: .5rem; height:auto !important; overflow:visible !important; }
      .cart-audio-ui { display:flex; flex-direction:column; align-items:stretch; gap:.35rem; }
      .cart-audio-row-top { display:flex; align-items:center; gap:.5rem; width:100%; min-width:0; }
      .cart-audio-row-bottom { display:flex; align-items:center; justify-content:flex-start; gap:.35rem; width:100%; }
      .cart-audio-row-track { display:flex; align-items:baseline; justify-content:flex-start; width:100%; }

.cart-audio-bar { height:12px; border-radius:999px; overflow:hidden; flex:1; min-width:120px; background:transparent; }
      .cart-audio-fill { height:100%; width:0%; opacity:.18; background:currentColor; }
      .cart-audio-time { font-size:12px; opacity:.7; min-width:44px; text-align:right; }
      .cart-audio-note { display:none; } /* visitor doesn't need this */
      .cart-audio-btn { width:46px; height:46px; border-radius:999px; border:1px solid rgba(0,0,0,.15); background:rgba(159,255,196,.55); display:flex; align-items:center; justify-content:center; cursor:pointer; }
      .cart-audio-btn:hover { background:rgba(159,255,196,.75); }
      .cart-audio-navbtn { width:28px; height:28px; border-radius:999px; border:1px solid rgba(0,0,0,.12); background:rgba(0,0,0,.04); display:flex; align-items:center; justify-content:center; cursor:pointer; font-size:14px; line-height:1; }
      .cart-audio-navbtn:hover { background:rgba(0,0,0,.08); }
      .cart-audio-trackline { display:flex; align-items:baseline; gap:.35rem; font-size:13px; line-height:1.2; white-space:nowrap; }
      .cart-audio-count { font-size:11px; opacity:.65; }
      @media (max-width: 520px){
        .cart-audio-ui { flex-direction:column; align-items:stretch; }
        .cart-audio-row-top { width:100%; }
        .cart-audio-row-bottom { width:100%; justify-content:flex-start; }
        .cart-audio-bar { min-width:0; }
        .cart-audio-time { min-width:42px; }
      }
    `;
    document.head.appendChild(style);
  }

  // --- Playlist helpers (dynamic total track count) ---
  // We can't reliably HEAD/GET Shopify CDN due to CORS, so we probe with <audio>.
  const __playlistTotalCache = window.__CART_AUDIO_PLAYLIST_TOTALS__ || (window.__CART_AUDIO_PLAYLIST_TOTALS__ = {});

  function getNumberedBase(url) {
    const mm = String(url || '').match(/^(.*-)(\d+)(\.mp3(?:\?.*)?)$/i);
    if (!mm) return null;
    return { prefix: mm[1], suffix: mm[3] };
  }

  function probeAudioUrl(url, timeoutMs) {
    return new Promise((resolve) => {
      try {
        const a = new Audio();
        a.preload = 'metadata';
        let done = false;
        const finish = (ok) => {
          if (done) return;
          done = true;
          try { a.src = ''; } catch (e) {}
          resolve(!!ok);
        };
        const t = setTimeout(() => finish(false), timeoutMs || 2000);
        a.addEventListener('loadedmetadata', () => { clearTimeout(t); finish(true); }, { once: true });
        a.addEventListener('error', () => { clearTimeout(t); finish(false); }, { once: true });
        a.src = url;
      } catch (e) {
        resolve(false);
      }
    });
  }

  async function computeEffectiveTotal(playlist) {
    if (!playlist || playlist.length <= 1) return (playlist ? playlist.length : 0);
    const base = getNumberedBase(playlist[0]);
    if (!base) return playlist.length;

    const cacheKey = base.prefix + base.suffix;
    if (__playlistTotalCache[cacheKey]) return __playlistTotalCache[cacheKey];

    let max = 0;
    for (let i = 1; i <= playlist.length; i++) {
      const url = base.prefix + String(i) + base.suffix;
      // eslint-disable-next-line no-await-in-loop
      const ok = await probeAudioUrl(url, 1800);
      if (!ok) break;
      max = i;
    }
    if (!max) max = 1;
    __playlistTotalCache[cacheKey] = max;
    return max;
  }


  function buildUI(el) {
    ensureStyles();
    el.innerHTML = `
      <div class="cart-audio-ui">
        <div class="cart-audio-row-top">
          <div class="cart-audio-bar border border-current relative"
            role="slider"
            aria-label="Preview position"
            aria-valuemin="0"
            aria-valuemax="100"
            aria-valuenow="0"
            tabindex="0">
            <div class="cart-audio-fill absolute left-0 top-0 bottom-0 pointer-events-none"></div>
          </div>
          <div class="cart-audio-time">0:00</div>
        </div>

        <div class="cart-audio-row-bottom">
          <button type="button" class="cart-audio-navbtn cart-audio-prev" aria-label="Previous track">‹</button>
          <button type="button" class="cart-audio-btn" aria-label="Play preview">▶</button>
          <button type="button" class="cart-audio-navbtn cart-audio-next" aria-label="Next track">›</button>
        </div>

        <div class="cart-audio-row-track">
          <div class="cart-audio-trackline">
            <span class="cart-audio-tracktext"></span>
            <span class="cart-audio-count"></span>
          </div>
        </div>
      </div>
      <div class="cart-audio-note"></div>
    `;

    return {
      btn: el.querySelector('.cart-audio-btn'),
      bar: el.querySelector('.cart-audio-bar'),
      fill: el.querySelector('.cart-audio-fill'),
      time: el.querySelector('.cart-audio-time'),
      prev: el.querySelector('.cart-audio-prev'),
      next: el.querySelector('.cart-audio-next'),
      note: el.querySelector('.cart-audio-note'),
      trackText: el.querySelector('.cart-audio-tracktext'),
      trackCount: el.querySelector('.cart-audio-count'),
    };
  }

  function findCartLineRoot(lineKey){
    if(!lineKey) return null;
    try { return document.querySelector(`[data-cart-item-key="${CSS.escape(lineKey)}"]`); }
    catch(e){ return document.querySelector(`[data-cart-item-key="${lineKey}"]`); }
  }
  function findCartPrimaryImg(lineKey){
    const root = findCartLineRoot(lineKey);
    if(!root) return null;
    let img = root.querySelector('[data-cart-item-image] img, img[data-cart-item-image], img.cart-item__image');
    if(img) return img;
    return root.querySelector('img');
  }
  function urlToArtCandidates(mp3Url){
    const base = String(mp3Url||'').trim();
    if(!base) return [];
    const png = base.replace(/\.mp3(\?.*)?$/i, '.png$1');
    const jpg = base.replace(/\.mp3(\?.*)?$/i, '.jpg$1');
    const jpeg = base.replace(/\.mp3(\?.*)?$/i, '.jpeg$1');
    return dedupeKeepOrder([png,jpg,jpeg]);
  }
  function setImgSrc(img,url){
    if(!img || !url) return;
    try{
      img.src = url;
      if(img.hasAttribute('srcset')) img.setAttribute('srcset','');
    }catch(e){}
  }

  function initOne(el){
    if(el.getAttribute(INIT_ATTR)==='1') return;

    const previewUrl = (el.dataset.previewUrl||'').trim();
    const previewPlaylistRaw = (el.dataset.previewPlaylist||'').trim();
    const trackTitles = splitPipe(el.dataset.trackTitles||'');
    const trackArtworks = splitPipe(el.dataset.trackArtworks||'');
    const lineKey = (el.dataset.lineKey||'').trim();

    let playlist = dedupeKeepOrder(splitPipe(previewPlaylistRaw));
    const initialUrl = previewUrl || (playlist[0]||'');
    if(!initialUrl) return;

    const startPercent = Number(el.dataset.previewStart||45);
    const previewDuration = Number(el.dataset.previewDuration||90);
    const autoplay = parseBool(el.dataset.autoplay||'false');

    const ui = buildUI(el);
    const audio = new Audio(initialUrl);

    let playlistIndex = 0;
    if(playlist.length){
      const idx = playlist.indexOf(initialUrl);
      playlistIndex = idx>=0?idx:0;
    }
    let totalTracks = (playlist.length || trackTitles.length || trackArtworks.length || 1);

    let totalTracksEffective = totalTracks;

    if(!playlist.length || totalTracks<=1){
      ui.prev.style.display='none';
      ui.next.style.display='none';
    }

    // If this is an "All tracks" playlist, shrink to the number of real MP3s that exist (1..N contiguous).
    // This fixes cases where you generate 10 URLs but only 5 files exist.
    if (playlist.length > 1) {
      computeEffectiveTotal(playlist).then((n) => {
        totalTracksEffective = Math.max(1, Number(n) || 1);
        playlist = playlist.slice(0, totalTracksEffective);
        totalTracks = (playlist.length || trackTitles.length || trackArtworks.length || 1);
        if (playlistIndex >= playlist.length) playlistIndex = 0;
        syncMeta();
      });
    }

    let pendingAutoplay=false;
    audio.preload='metadata';

    let duration=null;
    let windowStart=0;
    let windowEnd=0;
    let scrubbing=false;
    let advancing=false;
    let wasPlayingBeforeScrub=false;

    function currentTitle(){
      if(trackTitles[playlistIndex]) return trackTitles[playlistIndex];
      return `Track ${playlistIndex+1}`;
    }
    function currentArt(){
      if(trackArtworks[playlistIndex]) return trackArtworks[playlistIndex];
      const url=(playlist[playlistIndex]||'').trim();
      const candidates=urlToArtCandidates(url);
      return candidates[0]||'';
    }
    function syncArtwork(){
      const title=currentTitle();
      const art=currentArt();

      const cartImg=findCartPrimaryImg(lineKey);
      if(cartImg && art){
        cartImg.alt=title;
        setImgSrc(cartImg, art);
      }
    }
    function syncMeta(){
      ui.trackText.textContent = currentTitle();
      ui.trackCount.textContent = (totalTracksEffective>1) ? ` (${playlistIndex+1}/${totalTracksEffective})` : '';
      syncArtwork();
    }

    function computeWindow(){
      if(!audio.duration || !isFinite(audio.duration)) return;
      duration = audio.duration;
      windowStart = clamp((startPercent/100)*duration, 0, Math.max(0, duration-0.001));
      windowEnd = clamp(windowStart + previewDuration, windowStart, duration);
      ui.note.textContent = `Preview: ${Math.round(startPercent)}% for ${Math.round(previewDuration)}s`;
      log('window', {initialUrl, duration, windowStart, windowEnd});
    }
    function windowSpan(){ return Math.max(0.001, windowEnd-windowStart); }

    function updateUI(){
      if(!duration) return;
      const pos = clamp(audio.currentTime, windowStart, windowEnd);
      const pct = ((pos-windowStart)/windowSpan())*100;
      ui.fill.style.width = `${clamp(pct,0,100)}%`;
      ui.time.textContent = formatTime(pos-windowStart);
      ui.bar.setAttribute('aria-valuenow', String(Math.round(clamp(pct,0,100))));
      syncMeta();
    }

    function enforceWindow(){
      if(!duration) return;
      if(scrubbing) return;
      if(audio.currentTime < windowStart) audio.currentTime = windowStart;
      if(audio.currentTime > windowEnd){
        // End of preview window: if we have a playlist, auto-advance (and wrap) instead of pausing.
        if(playlist && playlist.length > 1 && !advancing){
          advancing = true;
          const shouldPlay = !audio.paused;
          setTrack(playlistIndex+1, shouldPlay);
          // setTrack() will reload + (optionally) restart playback on loadedmetadata
          return;
        }
        audio.pause();
        audio.currentTime = windowStart;
        ui.btn.textContent='▶';
      }
    }

    function playFromStart(){
      stopAllCartAudio();
      active = { audio, ui, el, lineKey };
      if(duration) audio.currentTime = windowStart;
      audio.play().catch(e=>log('play() blocked', e));
    }
    function toggle(){
      if(audio.paused) playFromStart();
      else audio.pause();
    }

    function pctFromEvent(evt){
      const rect = ui.bar.getBoundingClientRect();
      const clientX = (evt.touches && evt.touches[0] && evt.touches[0].clientX) ? evt.touches[0].clientX : evt.clientX;
      const x = clamp(clientX-rect.left, 0, rect.width||1);
      return x/(rect.width||1);
    }
    function setPosFromPct(pct01){
      if(!duration) return;
      const t = windowStart + clamp(pct01,0,1)*windowSpan();
      audio.currentTime = clamp(t, windowStart, windowEnd);
      updateUI();
    }
    function onPointerDown(evt){
      if(!duration) return;
      evt.preventDefault();
      scrubbing=true;
      wasPlayingBeforeScrub = !audio.paused;
      stopAllCartAudio();
      active = { audio, ui, el, lineKey };
      setPosFromPct(pctFromEvent(evt));
      window.addEventListener('mousemove', onPointerMove, {passive:false});
      window.addEventListener('mouseup', onPointerUp, {passive:false});
      window.addEventListener('touchmove', onPointerMove, {passive:false});
      window.addEventListener('touchend', onPointerUp, {passive:false});
    }
    function onPointerMove(evt){
      if(!scrubbing || !duration) return;
      evt.preventDefault();
      setPosFromPct(pctFromEvent(evt));
    }
    function onPointerUp(evt){
      if(!scrubbing) return;
      evt.preventDefault();
      scrubbing=false;
      if(wasPlayingBeforeScrub){
        audio.play().catch(()=>{});
      }
      updateUI();
      window.removeEventListener('mousemove', onPointerMove);
      window.removeEventListener('mouseup', onPointerUp);
      window.removeEventListener('touchmove', onPointerMove);
      window.removeEventListener('touchend', onPointerUp);
    }
    // --- Scrubbing (RESTORED, SAFE) ---
function bindScrubBar() {
  if (!ui.bar) return;

  ui.bar.addEventListener('mousedown', onPointerDown);
  ui.bar.addEventListener('touchstart', onPointerDown, { passive: false });

  ui.bar.style.cursor = 'pointer';
}

bindScrubBar();


    ui.bar.addEventListener('keydown', (evt)=>{
      if(!duration) return;
      const step = 0.05;
      const pos = clamp(audio.currentTime, windowStart, windowEnd);
      const pct01 = (pos-windowStart)/windowSpan();
      if(evt.key==='ArrowLeft' || evt.key==='ArrowDown'){ evt.preventDefault(); setPosFromPct(pct01-step); }
      if(evt.key==='ArrowRight' || evt.key==='ArrowUp'){ evt.preventDefault(); setPosFromPct(pct01+step); }
      if(evt.key==='Home'){ evt.preventDefault(); setPosFromPct(0); }
      if(evt.key==='End'){ evt.preventDefault(); setPosFromPct(1); }
    });

    function setTrack(newIndex, shouldPlay){
      if(!playlist.length) return;
      const len = playlist.length;
      playlistIndex = ((newIndex % len) + len) % len; // wrap
      const url = playlist[playlistIndex];
      if(!url) return;
      pendingAutoplay = !!shouldPlay;
      audio.src = url;
      audio.load();
      syncMeta();
    }

    audio.addEventListener('loadedmetadata', ()=>{
      computeWindow();
      audio.currentTime = windowStart;
      updateUI();
      if(autoplay){
        playFromStart();
        return;
      }
      if(pendingAutoplay){
        pendingAutoplay=false;
        playFromStart();
      }
      advancing = false;
    });
    audio.addEventListener('error', ()=>{ advancing = false; });

    audio.addEventListener('timeupdate', ()=>{ enforceWindow(); updateUI(); });

    // auto-advance and wrap
    audio.addEventListener('ended', ()=>{
      if(!playlist.length) return;
      setTrack(playlistIndex+1, true);
    });

    audio.addEventListener('play', ()=>{
      ui.btn.textContent='⏸';
      active = { audio, ui, el, lineKey };
      syncMeta();
    });
    audio.addEventListener('pause', ()=>{ ui.btn.textContent='▶'; syncMeta(); });

    ui.prev.addEventListener('click', ()=>{
      if(!playlist.length) return;
      const wasPlaying = !audio.paused;
      setTrack(playlistIndex-1, wasPlaying);
    });
    ui.next.addEventListener('click', ()=>{
      if(!playlist.length) return;
      const wasPlaying = !audio.paused;
      setTrack(playlistIndex+1, wasPlaying);
    });

    ui.btn.addEventListener('click', toggle);

    // stop if line vanishes
    const observer = new MutationObserver(()=>{
      if(!lineKey) return;
      const stillThere = findCartLineRoot(lineKey);
      if(!stillThere && active && active.el===el){
        stopAllCartAudio();
      }
    });
    observer.observe(document.body, {childList:true, subtree:true});

    syncMeta();
    el.setAttribute(INIT_ATTR,'1');
  }

  function initAll(root){
    (root||document).querySelectorAll(SELECTOR).forEach(initOne);
  }

  document.addEventListener('DOMContentLoaded', ()=>{
    initAll(document);

    document.body.addEventListener('label:modalcart:afteradditem', ()=>{
      setTimeout(()=>initAll(document), 50);
    });

    const mo = new MutationObserver(()=>initAll(document));
    mo.observe(document.body, {childList:true, subtree:true});
  });

  window.CartWaveform = window.CartWaveform || {};
  window.CartWaveform.init = initAll;
  window.CartWaveform.initAll = initAll;
  window.CartWaveform.stopAll = stopAllCartAudio;
  window.CartWaveform.pauseAll = stopAllCartAudio;

  // Back-compat alias used by some product-page glue code
  window.CartWaveformPlayer = window.CartWaveformPlayer || {};
  window.CartWaveformPlayer.initAll = initAll;
  window.CartWaveformPlayer.init = initAll;
  window.CartWaveformPlayer.pauseAll = stopAllCartAudio;
  window.CartWaveformPlayer.stopAll = stopAllCartAudio;
})();